import { render, staticRenderFns } from "./ActivityDetailsForm.vue?vue&type=template&id=6e594002"
import script from "./ActivityDetailsForm.vue?vue&type=script&lang=js"
export * from "./ActivityDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports